import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const ChannelsCenterGate = React.lazy(() => import("./ChannelsCenter.gate"));

const ChannelsCenterLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <ChannelsCenterGate />
  </React.Suspense>
);

export default ChannelsCenterLoadable;
